angular
  .module('contributor')

  .factory('UpdateContributorsLastTaskCrud', [
    'Crud',

    function(Crud) {
      'use strict';

      class UpdateContributorsLastTaskCrud extends Crud {
        constructor() {
          super(null, '@@apiUrl' + '/set-contributors-last-task', {}, {});
        }
      }
      return UpdateContributorsLastTaskCrud;
    }
  ]);
